import { get, patch, post } from '../../utils/http';

export const fetchPeriod = ({ accountId, branchId, date }) =>
  get(`/accounts/${accountId}/branches/${branchId}/periods`, { date });

export const createPeriod = ({ accountId, branchId, date }) =>
  post(`/accounts/${accountId}/branches/${branchId}/periods`, { date });

export const updatePeriod = ({ accountId, branchId, id, ...params }) =>
  patch(`/accounts/${accountId}/branches/${branchId}/periods/${id}`, params);
